<script>
    import { apiUrl } from "@/utils";

    export default {
        name: "ProductInstructions",
        props: {
            instructions: Array,
        },
        methods: {
            apiUrl,
        },
    };
</script>

<template>
    <div class="product-instructions">
        <div class="product-instructions__title">Инструкции</div>
        <ul class="product-instructions__list">
            <li
                class="product-instructions__item"
                v-for="instruction in instructions"
                :key="instruction.id"
            >
                <a
                    :href="apiUrl(instruction.file)"
                    class="product-instructions__link"
                    target="_blank"
                >
                    {{ instruction.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
    .product-instructions {
        position: relative;
        @include bp($bp-desktop-sm) {
        }
    }

    .product-instructions__title {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: bold;
        line-height: 26px;
    }

    .product-instructions__item {
        position: relative;
        padding-left: 10px;
        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 9px;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: var(--dot-list-style);
        }
        &:not(:last-child) {
            margin-bottom: 8px;
        }
    }

    .product-instructions__link {
        color: #007bed;
        font-size: 14px;
        line-height: 22px;
        @include bp($bp-desktop-sm) {
            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>
